import { FC, useState } from 'react';
import { Paper, Modal, Grid, Button, Input, IconButton } from '@material-ui/core';
import { useStyles } from './styles';
import { useHistory } from 'react-router-dom';
import { useStore } from 'hooks/useRootStore';
import { ClientActivatePopUpProps, ClientActivateInfo } from './types';
import CloseIcon from '@material-ui/icons/Close';
import { Controller, useForm } from 'react-hook-form';
import { observer } from 'mobx-react-lite';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { useMutation } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { handleCompanyUrl } from 'utils/organizationUtils';
import { handleSampleDownload } from 'utils/urlUtils';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
// const organizationBlockMock1: LogsInfoFormInput<ClientActivateInfo>[] = [
//   //{ name: 'type', title: 'Select Data Type', placeholder: 'LDAP', required: true, type: 'select', options: ['LDAP', 'CSV'] },
//   {
//     name: 'securityType',
//     title: 'Security type:',
//     placeholder: 'NONE',
//     required: true,
//     type: 'select',
//     options: ['None', 'TLS', 'SSL'],
//   },
//   {
//     name: 'host',
//     title: 'Host name',
//     placeholder: 'ldap.forumsys.com',
//     required: true,
//   },
//   {
//     name: 'directory',
//     title: 'Directory Type',
//     placeholder: 'Active Directory',
//     required: true,
//     type: 'select',
//     options: ['Active Directory', 'OpenLDAP', 'Novell', 'Oracle', 'Ping', 'LDAP'],
//   },
//   { name: 'port', title: 'Port', placeholder: '838 or 636', required: true },
//   {
//     name: 'baseDn',
//     title: 'BasedDN (optional):',
//     placeholder: 'dc=example,dc=com',
//     required: false,
//   },
//   { name: 'username', title: 'UserDN', placeholder: 'uid=tesla, dc=example, dc=com', required: true },
//   { name: 'password', title: 'Password', placeholder: '******', required: true },
// ];

export const NewDataSourcePopup: FC<ClientActivatePopUpProps> = observer(({ open, handleClose, id }) => {
  const {
    importStore: { setStep, ldapNewConnect, ldapGetConnectOptions, sendCsvFile, sendLdifFile },
    notificationStore: { openNotification },
  } = useStore();
  // const sample = ['CSV', 'LDIF'];
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [rerenderKey, setRerenderKey] = useState(0);
  const [selectType] = useState('CSV');
  const [selectTypes] = useState('LDAP');
  const classes = useStyles();
  const { control, handleSubmit, reset } = useForm<ClientActivateInfo>();
  const addNewSourceRequest = useMutation((data: ClientActivateInfo) => ldapNewConnect(data), {
    mutationKey: 'ldapNewConnect',
    onSuccess: () => {
      openNotification('success', `Successfully updated`);
      reset();
      handleClose();
      ldapGetConnectOptionsReq.mutate();
    },
    onError: () => openNotification('error', `Can't update user`),
  });
  const ldapGetConnectOptionsReq = useMutation('ldapGetConnectOptions', () => ldapGetConnectOptions(), {
    onError: ({ message }: Error) => openNotification('error', message),
  });
  const history = useHistory();
  const sendCsvFileReq = useMutation((data: unknown) => sendCsvFile(data), {
    mutationKey: 'sendInvitationReq',
    onSuccess: (e) => {
      openNotification('success', e?.message || 'File uploaded successfully');
      reset();
      setSelectedFile(null);
      setIsFilePicked(false);
      handleClose();
      setStep('two');
      ldapGetConnectOptionsReq.mutate();
    },
    onError: (e: any) => {
      openNotification('error', `${e}`);
      reset();
      setIsFilePicked(false);
      // history.push(handleCompanyUrl('/upgrade-license'));
    },
  });
  const sendLdapFileReq = useMutation((data: unknown) => sendLdifFile(data), {
    mutationKey: 'sendInvitationReq',
    onSuccess: (e) => {
      openNotification('success', e?.message || 'File uploaded successfully');
      reset();
      setSelectedFile(null);
      setIsFilePicked(false);
      handleClose();
      setStep('two');
      ldapGetConnectOptionsReq.mutate();
    },
    onError: (e: any) => {
      openNotification('error', `${e?.message || e}`);
      if (e?.licensePage) {
        history.push(handleCompanyUrl('/upgrade-license'));
      }
    },
  });
  const onSubmit = (data: ClientActivateInfo) => {
    const fileData = { ldapFile: selectedFile };
    if (isFilePicked) {
      selectType === 'CSV' ? sendCsvFileReq.mutate(fileData) : sendLdapFileReq.mutate(fileData);
    } else {
      if (selectType === 'CSV') {
        sendCsvFileReq.mutate(fileData);
      } else if (selectType === 'LDAP') {
        sendLdapFileReq.mutate(fileData);
      }
    }
  };
  useAppPreloader(
    addNewSourceRequest.isLoading ||
      ldapGetConnectOptionsReq.isLoading ||
      sendCsvFileReq.isLoading ||
      sendLdapFileReq.isLoading
  );
  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files ? e.target.files[0] : null;
    if (selectedFile && file && selectedFile.name === file.name && selectedFile.size === file.size) {
      setIsFilePicked(true);
      setSelectedFile(file);
    } else {
      setIsFilePicked(!!file);
      setSelectedFile(file);
    }
    setRerenderKey((prevKey) => prevKey + 1);
  };

  return (
    <Modal key={rerenderKey} className={classes.modal} disablePortal disableEnforceFocus disableAutoFocus open={open}>
      {!addNewSourceRequest.isLoading ? (
        <Paper className={classes.paper} elevation={3}>
          <Grid className={classes.topBar} container justify='space-between' alignItems='center'>
            <div className={classes.title}>Upload User Accounts Data : CSV or LDIF File</div>
            <IconButton
              style={{ marginRight: -16 }}
              onClick={() => {
                handleClose();
                reset();
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
          <div className={classes.flexBox}>
            <form className={classes.formContainer} onSubmit={handleSubmit(onSubmit)}>
              <Grid container justify='space-between'>
                <Grid className={classes.block} container>
                  {/* <Grid className={classes.fullRow} container>
                    <FormControl className={classes.input}>
                      <InputLabel>Select Data Type:</InputLabel>
                      <Controller
                        render={({ field, fieldState: { invalid } }) => (
                          <Select
                             className={classes.input}
                            defaultValue={selectType}
                            onChange={(evt: any) => setSelectType(evt.target.value)}>
                            {sample.map((_item: any) => (
                              <MenuItem key={_item} value={_item}>
                                {_item}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                        name='type'
                        defaultValue={selectType}
                        control={control}
                      />
                    </FormControl>
                  </Grid> */}

                  {/* {selectedtype === 'LDAP' &&
                    organizationBlockMock1.map((item, index: number) =>
                      item.type !== 'select' ? (
                        <Controller
                          key={index}
                          name={item.name}
                          // defaultValue={clientActivationInfo?.[item.name]}
                          control={control}
                          rules={{ required: item?.required }}
                          render={({ field, fieldState: { invalid } }) => (
                            <Grid container className={classes.row}>
                              <TextField
                                {...field}
                                type={item.name === 'password' ? 'password' : undefined}
                                label={item.title}
                                disabled={item.disabled}
                                error={invalid}
                                placeholder={item.placeholder}
                                helperText={invalid ? 'Required field' : ''}
                                className={classes.input}
                              />
                            </Grid>
                          )}
                        />
                      ) : (
                        <Controller
                          name={item.name}
                          control={control}
                          rules={{ required: item?.required }}
                          render={({ field, fieldState: { invalid } }) => (
                            <Grid className={classes.row} container>
                              <FormControl className={classes.input}>
                                <InputLabel id={item.name}>{item.title}</InputLabel>
                                <Select
                                  {...field}
                                  defaultValue={item?.options !== undefined && item.options[0]}
                                  error={invalid}
                                  className={classes.input}>
                                  {item.options?.map((_item: any) => (
                                    <MenuItem key={_item} value={_item}>
                                      {_item}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                          )}
                        />
                      )
                    )} */}
                </Grid>

                <div className={classes.csvFile}>
                  <Grid className={classes.row} container justify='space-between'>
                    {
                      <div
                        className={classes.textFileField}
                        onDragOver={(e) => {
                          e.preventDefault();
                        }}
                        onDrop={(e) => {
                          e.preventDefault();
                          const file = e.dataTransfer.files[0];
                          setSelectedFile(file);
                          setIsFilePicked(true);
                        }}
                      >
                        <label
                          style={{
                            cursor: 'pointer',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '10px',
                          }}
                          htmlFor='file'
                        >
                          <>
                            {' '}
                            <div>
                              <div>
                                <CloudUploadIcon className={classes.uploadIcon} />
                              </div>
                              <div className={classes.uploadtext}>Drag & Drop your file with User Data</div>
                              <div className={classes.spanOr}>
                                <span>OR</span>
                              </div>
                            </div>
                            <div className={classes.fileadjust}>
                              <span className={classes.ChooseFile}>Choose a file</span>
                            </div>
                          </>
                        </label>
                      </div>
                    }

                    <Controller
                      render={({ field, fieldState: { invalid } }) => (
                        <Input
                          {...field}
                          className={classes.textField}
                          rows={4}
                          type='file'
                          error={invalid}
                          style={{ display: 'none' }}
                          id='file'
                          onChange={handleFileSelect}
                        />
                      )}
                      control={control}
                      name='directory'
                    />
                  </Grid>
                </div>
                {isFilePicked ? (
                  <Grid container justify='space-between' className={classes.fileInfo}>
                    <>
                      <Grid item xs={10}>
                        <p className={classes.fileadjustUpload}>
                          <span className={classes.filename}> {selectedFile?.name}</span>
                          <span className={classes.filesize}> ({selectedFile?.size} kb)</span>
                        </p>
                      </Grid>
                      <Grid item xs={2} className={classes.fileicon}>
                        <Button
                          onClick={() => {
                            setSelectedFile(null);
                            setIsFilePicked(false);
                          }}
                          className={classes.space}
                        >
                          <CloseIcon className={classes.fileiconbtn} />
                        </Button>
                      </Grid>
                    </>
                  </Grid>
                ) : null}

                <Grid>
                  <Grid className={classes.block}>
                    <div className={classes.buttonsDiv}>
                      <Button
                        className=''
                        onClick={() => {
                          if (selectType && selectType) {
                            selectType === 'CSV'
                              ? handleSampleDownload(process.env.REACT_APP_DOWN_CSV as string, 'csv')
                              : handleSampleDownload(process.env.REACT_APP_DOWN_LDIF as string, 'ldif');
                          }
                        }}
                        variant='contained'
                        color='secondary'
                      >
                        <CloudDownloadIcon style={{ margin: '8px' }} />
                        {selectType && selectType === 'CSV' ? 'Sample CSV' : 'Sample LDIF'}
                      </Button>
                    </div>
                    <div className={classes.buttonsDiv}>
                      <Button
                        className=''
                        onClick={() => {
                          if (selectTypes && selectTypes) {
                            selectTypes === 'LDAP'
                              ? handleSampleDownload(process.env.REACT_APP_DOWN_LDIF as string, 'ldif')
                              : handleSampleDownload(process.env.REACT_APP_DOWN_CSV as string, 'csv');
                          }
                        }}
                        variant='contained'
                        color='secondary'
                      >
                        <CloudDownloadIcon style={{ margin: '8px' }} />
                        {selectTypes && selectTypes === 'LDAP' ? 'Sample LDIF' : 'Sample CSV'}
                      </Button>
                    </div>

                    <div className={classes.buttonsDiv}>
                      <Grid container className={classes.rowButton}>
                        <Button
                          className={classes.btn}
                          onClick={() => {
                            handleClose();
                            // setSelectedtype('LDAP');
                          }}
                          variant='contained'
                          color='primary'
                        >
                          Cancel
                        </Button>
                      </Grid>
                      <Grid container className={classes.rowButton}>
                        <Button className={classes.btn} type='submit' variant='contained' color='secondary'>
                          Next
                        </Button>
                      </Grid>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </div>
        </Paper>
      ) : (
        <></>
      )}
    </Modal>
  );
});
